<template >
  <div class="product-wrap-type">
    <div class="addto_amount clearfix" v-if="product.spread">
      <a class="right addto_amount_it" href="javascript:void(0);" @click="selectType([product, 'spread', $event]);" v-bind:class="{ active: product.selected == 'spread' }">פרוס</a>
      <a class="right addto_amount_it" href="javascript:void(0);" @click="selectType([product, 'full', $event]);" v-bind:class="{ active: product.selected == 'full' }">שלם</a>
    </div>
    <div class="addto_amount clearfix" v-if="product.type == 'both'">
      <a class="right addto_amount_it" href="javascript:void(0);" @click="selectType([product, 'unit', $event]);" v-bind:class="{
          active: !product.selected || product.selected == 'unit'
        }">יח׳</a>
      <a class="right addto_amount_it" href="javascript:void(0);" @click="selectType([product, 'kg', $event]);" v-bind:class="{ active: product.selected == 'kg' }">ק״ג</a>
    </div>
    <div class="addto_amount clearfix amount_one" v-if="product.type == 'unit' && !product.case && !product.spread">יח׳</div>
    <div class="addto_amount clearfix amount_one" v-if="product.type == 'kg'">ק״ג</div>
    <div class="addto_amount clearfix amount_one" v-if="!product.case && product.type == 'unitaskg'">יח׳</div>
    <div class="addto_amount clearfix amount_one" v-if="product.case && (product.type == 'unit' || product.type == 'unitaskg')">מארז</div>
  </div>
</template>
<script>
  import { mapActions } from "vuex";
  export default {
    props: ["product","readonly"],
    computed: {
      isReadonly:function(){
        if (typeof this.readonly !='undefined') {
          return true;
        }
        return false;
      }
    },
    methods: {
      ...mapActions(["selectType"])
    }
  };
</script>
